import React from "react";

import TextInput from "../../../../components/formElements/input/TextInput";
import Row from "../../../../components/uiElements/grid/Row";
import Col from "../../../../components/uiElements/grid/Col";
import Card from "../../../../layout/Onboarding/Card";
import Lable from "../../../../components/formElements/label/Label";
import CardLable from "../../../../components/formElements/label/CardLabel";

export const AllergyDetailsCard = ({
  personalPatientInfo,
  addAllergy,
  setPatientPersonalInfo,
  removeAllergy,
  form,
}) => {
  return (
    <Card>
      <Row className="mt-4 mb-4">
        <Col>
          <CardLable
            name="Allergies"
            condition={personalPatientInfo.currentAllergy}
            onclick={() => addAllergy()}
            labelName={personalPatientInfo.currentAllergy ? "Add" : ""}
          />
        </Col>
        <Col className="mt-3 mb-n4">
          <TextInput
            id="currentAllergy"
            // error={form.allergy}
            type="text"
            label="Allergies"
            value={personalPatientInfo.currentAllergy}
            onChange={val => setPatientPersonalInfo({ currentAllergy: val })}
          />
        </Col>
        {personalPatientInfo.allergy !== null
          ? personalPatientInfo.allergy.map((value, index) => (
              <Col className="mt-n1 mb-4">
                <Lable
                  name="allergy"
                  onclick={() => removeAllergy(index)}
                  value={value}
                />
              </Col>
            ))
          : ""}
      </Row>
    </Card>
  );
};
